import { CreateAlert } from '../../../shared/common-alerts/SKAlerts';

export const validateProductSubCategory = (payload, setAlert) => {
  if (!payload.CategoryId) {
    CreateAlert('Please select category!!', 'Warning', setAlert);
    return false;
  }
  if (!payload.SubCategoryName?.trim()) {
    CreateAlert('Please enter sub category name!!', 'Warning', setAlert);
    return false;
  }
  if (!payload.Slug?.trim()) {
    CreateAlert('Please enter slug!!', 'Warning', setAlert);
    return false;
  }
  if (payload.DisplayOrder !== '' && payload.DisplayOrder != null) {
    const order = Number(payload.DisplayOrder);
    if (Number.isNaN(order) || order < 0) {
      CreateAlert('Display order cannot be negative!!', 'Warning', setAlert);
      return false;
    }
  }
  return true;
};
